var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._l((_vm.list),function(item,index){return _c('public-item',{key:index,attrs:{"title":item.title,"code":item.code}})}),_c('dzs-backtop',{attrs:{"target":".el-main"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }